import React, {ReactNode} from "react";
import { formattedDate } from "../../../../helpers/DateHelpers";

import { StopOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

interface PropsInterface {
  name: string | ReactNode;
  bannedUntil?: string | undefined;
}

const _Title = ({ name, bannedUntil }: PropsInterface) => {
  const isBanned = bannedUntil && formattedDate(bannedUntil).raw > new Date();

  const BlockBadge = () => {
    if (isBanned) {
      return (
        <Tooltip title={`expire ${formattedDate(bannedUntil).fromNow}`}>
          <StopOutlined style={{ color: '#f5222d' }} />
        </Tooltip>
      )
    }

    return null;
  }

  return (
    <>
      {<BlockBadge />} #{name}
    </>
  );
}

export default _Title;
